import { useQuery } from '@tanstack/react-query';
import type { AxiosRequestConfig } from 'axios';
import { apiWrapper } from '@/apiWrapper';
import { getEndpoints } from '@/endpoints';
import type { AgentSearchLocation } from '../types';

const getLocationsBySearch = async (
  query: string,
): Promise<AgentSearchLocation[]> => {
  const url = getEndpoints().locations;
  const config: AxiosRequestConfig = {
    method: 'GET',
    params: {
      query,
    },
  };

  const results = await apiWrapper<AgentSearchLocation[]>(url, config);
  return results;
};

export const useLocationSearch = (query: string) => {
  return useQuery({
    queryKey: ['locationSearch', query],
    queryFn: () => (query ? getLocationsBySearch(query) : []),
    enabled: !!query && query.length >= 4,
  });
};
